module.exports = __webpack_public_path__ + "media/stylesheets/images/mission-cec7c330a8281a0764b06125edf9029a.svg";